import { Link } from 'react-router-dom';
import React from 'react';

function Komponisten() {
    return (

        <div
            className="bg-Komponisten-wrapper view"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-purple.svg'})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom left',
                minHeight: '100vh',
                width: '100%',
            }}
        >
            <main className="container" role="main">

                <Link to="/" className="back-btn">← Zurück</Link>
                <h1 className="section-title">Musikalische Komponisten benennen</h1>
            </main>


            <div className="slider-wrapper">
                <div className="slider-container">
                    <div className="slider">


                        <Link to="/komponistenlernfeld1" className="maincard card1" aria-label="KomponistenLernfeld1">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-komponisten.png'} alt="KomponistenLernfeld1" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">KomponistenLernfeld1</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>

                        <Link to="/komponistenlernfeld2" className="maincard card2" aria-label="KomponistenLernfeld2">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-komponisten.png'} alt="KomponistenLernfeld2" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">KomponistenLernfeld2</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>


                        <Link to="/komponistenlernfeld3" className="maincard card3" aria-label="KomponistenLernfeld3">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-komponisten.png'} alt="KomponistenLernfeld3" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">KomponistenLernfeld3</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>

                        <Link to="/komponistenlernfeld4" className="maincard card4" aria-label="KomponistenLernfeld4">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-komponisten.png'} alt="" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">KomponistenLernfeld4</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>


                        <Link to="/komponistenlernfeld5" className="maincard card5" aria-label="KomponistenLernfeld5">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-komponisten.png'} alt="" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">KomponistenLernfeld5</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

        </ div >

    );
}

export default Komponisten;